import { getTenureTypeByKey } from '../../../shared/model/constants/tenureType';

const convertTenureTypeToObject = (listings) =>
  listings.map((listing) => {
    const { tenureType } = listing.omniture;
    return ({
      tenureTypeObject: getTenureTypeByKey(tenureType),
      ...listing,
    });
  });

export default response => ({
  availableResults: response.availableResults,
  exactMatchListings: convertTenureTypeToObject(response.listings),
  surroundingSuburbListings: convertTenureTypeToObject(response.surroundingSuburbListings),
  surroundingSuburbTitle: response.surroundingSuburbTitle,
  advertising: response.advertising,
  resolvedLocations: response.resolvedLocations,
  clusters: response.clusters,
});
